import React from 'react';

const Dirt = () => {
    return (
        <div className="dirt">
            <div className="dirt-one">
                <div className="line"></div>
                <div className="circle"></div>
            </div>
            <div className="dirt-mini">
                <div className="line"></div>
                <div className="circle"></div>
            </div>
            <div className="dirt-mini">
                <div className="line"></div>
                <div className="circle"></div>
            </div>
            <div className="dirt-two">
                <div className="line"></div>
                <div className="circle"></div>
            </div>
            <div className="patch">
            </div>
            <div className="patch left">
            </div>
        </div>
    )
}

export default Dirt;